export default __webpack_public_path__ + "static/people-careers-f7eaeb6d22c35daf96e4d2bf1485d464.png";